import commonReducer from 'modules/common/commonSlice';
import healthPlansReducer from 'modules/healthPlans/healthPlansSlice';
import categoriesReducer from 'modules/categories/categoriesSlice';

export default {
  common: commonReducer,
  healthPlans: healthPlansReducer,
  categories: categoriesReducer,
};
